import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollToId = (id, retries = 12) => {
  const el = document.getElementById(id);
  if (!el) {
    if (retries > 0) setTimeout(() => scrollToId(id, retries - 1), 150);
    return;
  }
  const target = el.getBoundingClientRect().top + window.scrollY - 72;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const FadeUp = ({ children, delay = 0, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-base font-semibold uppercase tracking-[0.3em] text-flame">
    {children}
  </p>
);
